<template>
  <div>
    <b-row>
      <b-col cols="2">
        <b-button  variant="success" @click="showTariffLink">{{ $t('Add') }}</b-button>
      </b-col>
      <b-col cols="6">
        <b-form-group :label="$t('Select account')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="selectedAccount" :options="currentRow.accounts">
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table ref="tableTariffLinks" small striped hover :items="tariffLinks" :fields="tariffLinksFields" @row-clicked="rowTariffLinkClickHandler">
       <template v-slot:cell(actions)="row">
        <b-button size="sm" @click.stop="ClickOnDeleteTariffButton(row)" id="transparent">
          <b-img :src='deleteDocumentImage' />
        </b-button>
        <b-button size="sm" @click.stop="ClickOnEditTariffButton(row)" id="transparent">
          <b-img :src='editDocumentImage' />
        </b-button>
      </template>
    </b-table>

    <b-modal ref="tariffLink" hide-footer :title="$t('Tariff linl details')">
      <b-form-group label-align="right" :label="$t('Current tariff plan')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-select :options="listOfTariffs" v-model="selectedTariffs" :disabled="isEdit"/>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Next tariff plan')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-select :options="listOfNextTariffs" v-model="selectedNextTariffs">
            <template slot="first">
              <option value='Next'>{{ $t('Do not change') }}</option>
            </template>
          </b-form-select>
          <b-input-group-append>
            <b-button v-if="isEdit" @click="checkTarifflinkNow">{{ $t('Change now') }}</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-input-group>
          <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="stateAccountingPeriod" :placeholder="$t('Tap to select')"/>
          <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit" />
          <b-form-invalid-feedback id="inputFeedback">
            {{ $t('Select accounting period') }}
          </b-form-invalid-feedback>
        </b-input-group>
      </b-form-group>
      <b-form-group v-if="isEdit" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-button size="sm" variant="secondary" @click="showServiceLink">{{ $t('Create service link') }}</b-button>
      </b-form-group>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="checkTarifflink">Ok</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideTariffLink">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal ref="warning" hide-footer :title="$t('Warning')">
      <p>{{ $t('Next tariff plan contains services. Are you sure you want to use it?') }}</p>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="saveTarifflink">{{ $t('Yes') }}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click="hideWarning">{{ $t('No') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <FormAccountinfPeriod
      @displayAccountingPeriod="displayAccountingPeriod"
      v-model="newTariff.accounting_period_id"/>

    <b-modal hide-footer ref="modalOneTime" :title="$t('One-time service link')" @hidden="isShowOneTime = false" @show="isShowOneTime = true">
      <FormOneTime v-if="isShowOneTime"
      @makeToasts="makeToasts"
      @hideSelectService="hideOneTime"
      :currentUser="currentRow"
      :currentService="currentService"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"/>
    </b-modal>

    <b-modal hide-footer ref="modalPeriodic" :title="$t('Periodic service link')" @hidden="isShowPeriodic = false" @show="isShowPeriodic = true" size="lg">
      <FormPeriodic v-if="isShowPeriodic"
      :currentUser="currentRow"
      :currentService="currentService"
      @hideSelectService="hidePeriodic"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalIPTraffic" :title="$t('IP traffic service link')" @hidden="isShowTPTraffic = false" @show="isShowTPTraffic = true" size="lg">
      <FormIPTraffic v-if="isShowTPTraffic"
      @hideSelectService="hideIPTraffic"
      :currentUser="currentRow"
      :currentService="currentService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalHotspot" :title="$t('Hotspot service link')" @hidden="isShowHotspot = false" @show="isShowHotspot = true" size="lg">
      <FormHotspot v-if="isShowHotspot"
      @hideSelectService="hideHotspot"
      :currentUser="currentRow"
      :currentService="currentService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalDialup" :title="$t('Dial-up service link')" @hidden="isShowDialup = false" @show="isShowDialup = true" size="lg">
      <FormDialup v-if="isShowDialup"
      @hideSelectService="hideDialup"
      :currentUser="currentRow"
      :currentService="currentService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalTelephony" :title="$t('Telephony service link')" @hidden="isShowTelephony = false" @show="isShowTelephony = true" size="lg">
      <FormTelephony v-if="isShowTelephony"
      @hideSelectService="hideTelephony"
      :currentUser="currentRow"
      :currentService="currentService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalIPTV" :title="$t('IPTV service link')" @hidden="isShowIPTV = false" @show="isShowIPTV = true">
      <FormIPTV v-if="isShowIPTV"
      @hideSelectService="hideIPTV"
      :currentUser="currentRow"
      :currentService="currentService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"
      :accountingPeriodId="accountingPeriodId"/>
    </b-modal>

    <b-modal hide-footer ref="modalVideo" :title="$t('Video on demand')" @hidden="isShowVideo = false" @show="isShowVideo = true">
      <FormVideo v-if="isShowVideo"
      @hideSelectService="hideVideo"
      :currentUser="currentRow"
      :currentService="currentService"
      @makeToasts="makeToasts"
      :selectedAccount="selectedAccount"
      :tariffLinkId="tariffLinkId"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Confirmation')" ref="modalDeleteTariff">
      <h5>{{ $t('Are you sure you want to delete one of "Tariff links"?') }}</h5>
      <b-row>
        <b-col>
          <b-btn variant="danger" block @click="deleteTariff()">Ok</b-btn>
        </b-col>
        <b-col>
          <b-btn variant="secondary" block @click="hideDeleteTariff()">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>

   <b-modal hide-footer :title="$t('Select service')" ref="modalServiceLinks">
    <b-table ref="tableTariffLinks" small striped hover
      :items="serviceLinks"
      :fields="serviceLinksFields"
      selectable
      @row-selected="onRowSelected"
      select-mode="single"/>
      <b-row>
        <b-col>
          <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="selectServiceLink">{{ $t('Save')}}</b-button>
        </b-col>
        <b-col sm="1.5">
          <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalServiceLinks.hide">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
   </b-modal>
  </div>
</template>

<script>

import moment from 'moment'
import axiosInstance from '@/utils/api.js'
import FormAccountinfPeriod from '../serviceLinks/formAccountingPeriod'
import FormOneTime from '@/pages/users/usersAndGroups/detail/serviceLinks/formOnce.vue'
import FormPeriodic from '@/pages/users/usersAndGroups/detail/serviceLinks/formPeriodic.vue'
import FormIPTraffic from '@/pages/users/usersAndGroups/detail/serviceLinks/formIPTraffic.vue'
import FormHotspot from '@/pages/users/usersAndGroups/detail/serviceLinks/formHotspot.vue'
import FormDialup from '@/pages/users/usersAndGroups/detail/serviceLinks/formDialup.vue'
import FormTelephony from '@/pages/users/usersAndGroups/detail/serviceLinks/formTelephony.vue'
import FormIPTV from '@/pages/users/usersAndGroups/detail/serviceLinks/formIPTV.vue'
import FormVideo from '@/pages/users/usersAndGroups/detail/serviceLinks/formVOD.vue'

export default {
  components: {
    FormAccountinfPeriod,
    FormOneTime,
    FormPeriodic,
    FormIPTraffic,
    FormHotspot,
    FormDialup,
    FormTelephony,
    FormIPTV,
    FormVideo
  },
  props: {
    currentRow: null
  },
  data () {
    return {
      servicesUser: null,
      services: null,
      selectedServiceLink: null,
      serviceLinks: [],
      serviceLinksFields: [
        { key: 'service_id', label: this.$i18n.t('Service ID'), sortable: true },
        { key: 'service_name', label: this.$i18n.t('Service name'), sortable: true },
        { key: 'nameServicesType', label: this.$i18n.t('Service type'), sortable: true },
        { key: 'comment', label: this.$i18n.t('Comments'), sortable: true }
      ],
      listServices: [],
      isEdit: false,
      isShowOneTime: false,
      isShowPeriodic: false,
      isShowTPTraffic: false,
      isShowHotspot: false,
      isShowDialup: false,
      isShowTelephony: false,
      isShowIPTV: false,
      isShowVideo: false,
      selectedNextTariffs: 'Next',
      selectedTariffs: '',
      listOfTariffs: [],
      listOfNextTariffs: [],
      newTariff: {
        'user_id': 0,
        'account_id': 0,
        'first_tariff_id': 0,
        'second_tariff_id': 0,
        'accounting_period_id': 0,
        'tariff_link_id': 0,
        'change_now': false
      },
      empertyTariff: {
        'user_id': 0,
        'account_id': 0,
        'first_tariff_id': 0,
        'second_tariff_id': 0,
        'accounting_period_id': 0,
        'tariff_link_id': 0,
        'change_now': false
      },
      stateAccountingPeriod: false,
      accountingPeriod: null,
      selectAccountingPeriod: null,
      deleteDocumentImage: require('@/assets/img/document_delete.png'),
      editDocumentImage: require('@/assets/img/document_edit.png'),
      selectedAccount: null,
      tariffPlan: [],
      tariffs: [],
      tariffLinks: [],
      tariffLinksFields: [
        { key: 'id', label: this.$i18n.t('Tlink ID'), sortable: true },
        { key: 'current_tariff_id', label: this.$i18n.t('Current TP ID'), sortable: true },
        { key: 'current_tariff_name', label: this.$i18n.t('Current tariff plan'), sortable: true },
        { key: 'next_tariff_id', label: this.$i18n.t('Next TP ID'), sortable: true },
        { key: 'next_tariff_name', label: this.$i18n.t('Next tariff plan'), sortable: true },
        { key: 'accounting_period_id', label: this.$i18n.t('Accounting period'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      currentRowTariffLink: null,
      tariffLinkId: 0,
      accountingPeriodId: 0,
      currentService: {
        service_id: 0,
        service_name: ''
      },
      currentServiceInTariff: -1
    }
  },
  methods: {
    ClickOnDeleteTariffButton (row) {
      this.tariffPlan = row.item
      this.$refs.modalDeleteTariff.show()
    },
    hideDeleteTariff () {
      this.$refs.modalDeleteTariff.hide()
    },
    deleteTariff () {
      if (this.tariffPlan) {
        axiosInstance.delete(this.$store.getters.API_USERS_TARIFFLINKS + '?user_id=' + this.currentRow.user_id + '&account_id=' + this.selectedAccount + '&tplink_id=' + this.tariffPlan.id).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            this.$refs.modalDeleteTariff.hide()
            this.reloadTariffPlan()
            this.$emit('refreshServiceLinks')
          }
        })
      }
    },
    ClickOnEditTariffButton (row) {
      this.isEdit = true
      this.currentRowTariffLink = row.item
      this.showTariffLink()
    },
    rowTariffLinkClickHandler (row) {
      if (this.currentRowTariffLink) {
        this.currentRowTariffLink._rowVariant = ''
      }
      this.currentRowTariffLink = row
      this.$set(this.currentRowTariffLink, '_rowVariant', 'info')
    },
    async load () {
      this.selectedAccount = this.currentRow.accounts.length ? this.currentRow.accounts[0] : null
      this.services = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES).then(response => { return response.data })
    },
    async reloadTariffPlan () {
      if (this.selectedAccount) {
        this.tariffLinks = await axiosInstance.get(this.$store.getters.API_USERS_TARIFFLINKS + '?user_id=' + this.currentRow.user_id + '&account_id=' + this.selectedAccount).then(response => { return response.data })
        this.tariffs = await axiosInstance.get(this.$store.getters.API_TARIFFING_TARIFFS).then(response => { return response.data })
        for (let i in this.tariffLinks) {
          for (let j in this.tariffs) {
            if (this.tariffLinks[i].current_tariff_id === this.tariffs[j].id) {
              this.tariffLinks[i].current_tariff_name = this.tariffs[j].name
            }
            if (this.tariffLinks[i].next_tariff_id === this.tariffs[j].id) {
              this.tariffLinks[i].next_tariff_name = this.tariffs[j].name
            }
          }
        }
        this.$refs.tableTariffLinks.refresh()
      }
    },
    async showTariffLink () {
      this.newTariff.change_now = false
      this.selectedNextTariffs = 'Next'
      this.stateAccountingPeriod = false
      this.selectAccountingPeriod = ''
      this.accountingPeriod = await axiosInstance.get(this.$store.getters.API_TARIFFING_ACCOUNTING_PERIODS).then(response => { return response.data })
      for (let i in this.tariffs) {
        this.tariffs[i].value = this.tariffs[i].id
        this.tariffs[i].text = this.tariffs[i].name + ' (' + this.tariffs[i].id + ')'
      }
      this.listOfTariffs = this.tariffs
      this.listOfNextTariffs = this.tariffs
      for (let i in this.listOfTariffs) {
        if (this.isEdit) {
          this.selectedTariffs = this.currentRowTariffLink.current_tariff_id
        } else {
          this.selectedTariffs = this.listOfTariffs[i].value
          break
        }
      }
      if (this.isEdit) {
        this.selectedNextTariffs = this.currentRowTariffLink.next_tariff_id
      }
      for (let i in this.accountingPeriod) {
        if (this.isEdit) {
          if (this.accountingPeriod[i].id === this.currentRowTariffLink.accounting_period_id) {
            this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
            this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
            this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
          }
        } else {
          if (this.accountingPeriod[i].id === this.newTariff.accounting_period_id) {
            this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
            this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
            this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
          }
        }
      }
      this.$refs.tariffLink.show()
    },
    hideTariffLink () {
      this.newTariff = JSON.parse(JSON.stringify(this.empertyTariff))
      this.$refs.tariffLink.hide()
      this.isEdit = false
    },
    showWarning () {
      this.$refs.warning.show()
    },
    hideWarning () {
      this.newTariff.change_now = false
      this.$refs.warning.hide()
    },
    showFormAccountingPeriod () {
      this.$root.$emit('bv::show::modal', 'accoutingPeriod', '#btnShow')
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    displayAccountingPeriod () {
      for (let i in this.accountingPeriod) {
        if (this.accountingPeriod[i].id === this.newTariff.accounting_period_id) {
          this.accountingPeriod[i].begin = moment(Number(this.accountingPeriod[i].begin) * 1000).format('MM-DD-YYYY')
          this.accountingPeriod[i].end = moment(Number(this.accountingPeriod[i].end) * 1000).format('MM-DD-YYYY')
          this.selectAccountingPeriod = this.accountingPeriod[i].begin + ' / ' + this.accountingPeriod[i].end + ' (' + this.accountingPeriod[i].id + ')'
        }
      }
    },
    checkTarifflinkNow () {
      this.newTariff.change_now = true
      this.checkTarifflink()
    },
    checkTarifflink () {
      if (this.isEdit) {
        this.newTariff.accounting_period_id = this.currentRowTariffLink.accounting_period_id
        this.newTariff.tariff_link_id = this.currentRowTariffLink.id
      } else {
        if (!this.newTariff.accounting_period_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
          return
        }
      }
      this.newTariff.user_id = this.currentRow.user_id
      this.newTariff.account_id = this.selectedAccount
      this.newTariff.first_tariff_id = this.selectedTariffs
      if (this.selectedNextTariffs === 'Next') {
        this.newTariff.second_tariff_id = this.newTariff.first_tariff_id
      } else {
        this.newTariff.second_tariff_id = this.selectedNextTariffs
      }

      if (this.newTariff.second_tariff_id !== this.newTariff.first_tariff_id) {
        let isFirst = this.tariffs.find(el => {
          return el.id === this.newTariff.first_tariff_id
        })
        let isSecond = this.tariffs.find(el => {
          return el.id === this.newTariff.second_tariff_id
        })
        if (isFirst.services.length === isSecond.services.length) {
          let isFound = false
          for (let i in isFirst.services) {
            isFound = false
            for (let j in isSecond.services) {
              if (isFirst.services[i].parent_id === isSecond.services[j].parent_id) {
                isFound = true
                break
              }
            }
            if (!isFound) {
              this.showWarning()
              break
            }
          }
          if (isFound) {
            this.saveTarifflink()
          }
        } else {
          this.showWarning()
        }
      } else {
        this.saveTarifflink()
      }
    },
    async saveTarifflink () {
      this.$refs.warning.hide()
      let responseTariffLink = await axiosInstance.post(this.$store.getters.API_USERS_TARIFFLINKS, this.newTariff).then(response => { return response })
      if (responseTariffLink.data.error) {
        this.$root.$emit('makeToasts', 'danger', responseTariffLink.data.error, 'Error')
        return
      }
      this.tariffLinkId = responseTariffLink.data.tariff_link_id
      this.accountingPeriodId = this.newTariff.accounting_period_id
      this.listServices = await axiosInstance.get(this.$store.getters.API_USERS_SERVICES_IN_TARIFF_LINK + '?user_id=' + this.currentRow.user_id + '&account_id=' + this.selectedAccount + '&tariff_link_id=' + this.tariffLinkId).then(response => { return response.data })
      if (!this.isEdit) {
        this.openNextServiceInTariff()
      }
      this.$root.$emit('makeToasts')
      this.reloadTariffPlan()
      this.hideTariffLink()
    },
    showPeriodic () {
      this.$refs.modalPeriodic.show()
    },
    hidePeriodic () {
      this.$refs.modalPeriodic.hide()
      this.openNextServiceInTariff()
    },
    showOneTime () {
      this.$refs.modalOneTime.show()
    },
    hideOneTime () {
      this.$refs.modalOneTime.hide()
      this.openNextServiceInTariff()
    },
    showHotspot () {
      this.$refs.modalHotspot.show()
    },
    hideHotspot () {
      this.$refs.modalHotspot.hide()
      this.openNextServiceInTariff()
    },
    showDialup () {
      this.$refs.modalDialup.show()
    },
    hideDialup () {
      this.$refs.modalDialup.hide()
      this.openNextServiceInTariff()
    },
    showTelephony () {
      this.$refs.modalTelephony.show()
    },
    hideTelephony () {
      this.$refs.modalTelephony.hide()
      this.openNextServiceInTariff()
    },
    showIPTraffic () {
      this.$refs.modalIPTraffic.show()
    },
    hideIPTraffic () {
      this.$refs.modalIPTraffic.hide()
      this.openNextServiceInTariff()
    },
    showIPTV () {
      this.$refs.modalIPTV.show()
    },
    hideIPTV () {
      this.$refs.modalIPTV.hide()
      this.openNextServiceInTariff()
    },
    showVideo () {
      this.$refs.modalVideo.show()
    },
    hideVideo () {
      this.$refs.modalVideo.hide()
      this.openNextServiceInTariff()
    },
    openNextServiceInTariff () {
      if (++this.currentServiceInTariff < this.listServices.length) {
        let tmpService = this.listServices[this.currentServiceInTariff]
        switch (tmpService.service_type) {
          case 1:
            this.currentService.service_id = tmpService.service_id
            this.currentService.service_name = tmpService.service_name
            this.showOneTime()
            break
          case 2:
            this.currentService.service_id = tmpService.service_id
            this.showPeriodic()
            break
          case 3:
            this.currentService.service_id = tmpService.service_id
            this.showIPTraffic()
            break
          case 4:
            this.currentService.service_id = tmpService.service_id
            this.showHotspot()
            break
          case 5:
            this.currentService.service_id = tmpService.service_id
            this.showDialup()
            break
          case 6:
            this.currentService.service_id = tmpService.service_id
            this.showTelephony()
            break
          case 8:
            this.currentService.service_id = tmpService.service_id
            this.showIPTV()
            break
          case 9:
            this.currentService.service_id = tmpService.service_id
            this.showVideo()
            break
        }
      } else {
        this.$emit('refreshServiceLinks')
      }
    },
    onRowSelected (selected) {
      this.selectedServiceLink = selected[0]
    },
    async showServiceLink () {
      this.servicesUser = await axiosInstance.get(this.$store.getters.API_USERS_SERVICE_LINKS + '?account_id=' + this.selectedAccount).then(response => { return response.data })
      this.serviceLinks = []
      this.selectedServiceLink = null
      let tariffId = this.selectedTariffs
      let servicesuser = []
      this.serviceLinks = this.services.filter(function (value) {
        return value.tariff_id === tariffId
      })
      for (let el of this.servicesUser) {
        for (let elServices of this.services) {
          if (el.service_id === elServices.service_id) {
            servicesuser.push(elServices)
          }
        }
      }
      for (let el of servicesuser) {
        this.serviceLinks = this.serviceLinks.filter(function (value) {
          return (value.parent_id !== el.parent_id)
        })
      }
      for (let el of this.serviceLinks) {
        switch (el.service_type) {
          case 1:
            el.nameServicesType = this.$i18n.t('One-time service link')
            break
          case 2:
            el.nameServicesType = this.$i18n.t('Periodic service link')
            break
          case 3:
            el.nameServicesType = this.$i18n.t('IP traffic service link')
            break
          case 4:
            el.nameServicesType = this.$i18n.t('Hots pot service link')
            break
          case 5:
            el.nameServicesType = this.$i18n.t('Dial-up service link')
            break
          case 6:
            el.nameServicesType = this.$i18n.t('Telephony service link')
            break
          case 8:
            el.nameServicesType = this.$i18n.t('IPTV service link')
            break
          case 9:
            el.nameServicesType = this.$i18n.t('Video service link')
            break
        }
      }
      this.$refs.modalServiceLinks.show()
    },
    selectServiceLink () {
      if (!this.selectedServiceLink) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }

      this.accountingPeriodId = this.currentRowTariffLink.accounting_period_id
      this.listServices.push(this.selectedServiceLink)
      this.openNextServiceInTariff()
      this.$refs.modalServiceLinks.hide()
    }
  },
  watch: {
    selectAccountingPeriod: function (val) {
      if (this.selectAccountingPeriod.length > 0) {
        this.stateAccountingPeriod = true
      }
    },
    selectedAccount: function () {
      this.reloadTariffPlan()
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/tariffLinks/main.vue